
export default {
    name: 'LeeToast',
    data() {
        return {
            isShow: false,
            thetype: '',
            statusTitle: '',
            sett: '',
            settc: ''
        }
    },
    updated() {
        this.fade()
    },
    mounted() {
        this.fade()
    },
    watch: {
        type: {
            immediate: true,
            handler(value) {
                let types = ['success', 'error', 'loading']
                let fi = types.filter(function (el) {
                    return el.indexOf(value) > -1;
                })
                if (fi.length < 1) {
                    this.thetype = "success"
                } else {
                    this.thetype = value
                }
            }
        },
        value: {
            immediate: true,
            handler(value) {
                this.isShow = value
            }
        },
        title: {
            immediate: true,
            handler(value) {
                this.statusTitle = value
            }
        }
    },
    methods: {
        fade() {
            if (this.sett != '') {
                clearTimeout(this.sett)
            }
            if (this.settc != '') {
                clearTimeout(this.settc)
            }
            if (this.thetype === 'loading' && this.after != '') {
                // if (this.settc != '') {
                //     clearTimeout(this.settc)
                // }
                this.settc = setTimeout(() => {
                    this.thetype = this.after
                    this.statusTitle = this.afterTitle
                    setTimeout(() => {
                        this.thetype = this.type
                        this.statusTitle = this.title
                        this.$emit('input', false)
                    }, 2000)
                }, 3000)

            } else {
                this.sett = setTimeout(() => {
                    this.$emit('input', false)
                }, 3000)
            }
        }
    },
    props: {
        title: {
            type: String,
            default: '提示文字' //默认default
        },
        afterTitle: {
            type: String,
            default: '提示文字' //默认default
        },
        type: {
            type: String,
            default: 'success' //默认default
        },
        after: {
            type: String,
            default: '' //默认default
        },
        value: {
            type: Boolean,
            default: false //默认default
        }
    }
};
